import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
  useToast,
} from 'alm-react-components';
import React, { useContext, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { ActionType, constants, SubscriptionStatus } from '../../assets/constants/constants';
import { AppContext } from '../../context/AppProvider';
import useSubscription from '../../hooks/useSubscription';
import { checkCurrentDate, isEnrollmentDateAvailable } from '../../lib/utils';
import useGaEventTracking from '../../hooks/UseGaEventTracking';
import { analytics_category, analytics_event, analytics_label, appcues_event } from '../../assets/constants/staticContentConstants';
import { apis } from '../../services/alm';
import SvgIcon from './SvgIcon';
import { putAppCuesData } from '../../lib/appcues';

type logTextType = {
  programId: string;
  enrollProgramInstanceId: string;
  width: string;
  instanceId: string;
  enrolled?: string | null;
  quaterTag: string;
  quaterData: () => void;
  name: string;
  setIsEnroll: any;
  isEnroll: boolean;
  color?: boolean;
  quaterStartDate: any;
  year?: any;
  programCountEachQuarter?:any;
  setIsListing?:any
  fullYear?:any
};
const EnrollUser = (Props: logTextType) => {
  const { toast } = useToast();
  const location = useLocation();
  const enrolledId: any = location?.state?.enrolled;
  const enrolledName: any = location?.state?.enrolledName;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [, setEnrollMentProgInstance] = useState('');
  const [isEnrollmentEligible, setIsEnrollmentEligible] = useState(false);
  const [isEnrolledFromUrl, setIsEnrolledFromUrl] = useState(false);
  const { callSubscription, subscriptionResponse } = useSubscription();
  const { state, dispatch } = useContext(AppContext);
  const gaEventTracker = useGaEventTracking();
  // useRef to track if an enrollment action is in progress
  const isEnrolling = useRef(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const isEnrolled = queryParams.get("enrolled") === "true";
    if (isEnrolled) {
      setIsEnrolledFromUrl(true);
      // If props.isEnroll is not yet set but URL indicates enrollment, update parent component
      if (!Props.isEnroll) {
        Props.setIsEnroll(true);
      }
    }
  }, [location.search, Props]);


  useEffect(() => {
    if (Props.instanceId) setEnrollMentProgInstance(Props.enrollProgramInstanceId);
  }, [Props]);

  const handleEnroll = async () => {
    if(!checkCurrentDate(state?.user?.currentDate) )
      return
    if (state?.user?.sllCorporateAccount === null) {
     callSubscription('valid');
   }
   const today = new Date();
   const items = {
     value: null,
     currency: null,
     transaction_id: null,
     items: [{}],
     user_id: state.user?.userId,
     Program_quarter: location.state.year,
     Program_name: Props.name,
     enrollment_date: today.toLocaleDateString(),
     auto_enrollment: false,
   };
    gaEventTracker(analytics_event.enrollmentToProgram, analytics_category.buttonClickEnrollmentToProgram, analytics_label.enrollmentToProgramLable, items);
     putAppCuesData({
        event_Name: appcues_event.programJoined,
        eventName: `${appcues_event.programJoined}_${Props.programId}_${Props?.name}`,
        userId: state.user?.email || "",
        program_id: Props.programId,
        program_name: Props.name,});
    if (enrolledId && !state?.user?.sllCorporateAccount) {
      handleUnEnroll();
    } else {
      enrollUser();
    }
  };

  useEffect(() => {
    if (subscriptionResponse) {
      if (subscriptionResponse?.subscriptionStatus === constants.ACTIVE || subscriptionResponse?.subscriptionStatus === SubscriptionStatus.trial) {
        if (enrolledId) {
          handleUnEnroll();
        } else {
          enrollUser();
        }
      }
    }
  }, [subscriptionResponse]);

  const enrollUser = async () => {
    // Prevent multiple enroll calls if one is already in progress
    if (isEnrolling.current) {
      return;
    }
    isEnrolling.current = true;
    dispatch({ type: ActionType.SET_LOADING, payload: true });
    try {
    const enrolled = await apis.userEnroll(Props.programId, Props.instanceId);
    dispatch({ type: ActionType.SET_LOADING, payload: false });
    if (enrolled?.data?.attributes?.state == 'ENROLLED') {
      toast({
        description: (t('Program.entrolledSuccessMsg')),
        color: 'white',
        variant: 'success',
      });
      Props.quaterData();
      Props.setIsEnroll(true);
      navigate(`/program-overview?programId=${Props?.programId}&enrolled=${true}`, {
              state: {
                enrolled: enrolledId
                  ? enrolledId
                  : false,
                enrolledName: enrolledName,
                year: Props.fullYear,
                programCountEachQuarter:Props.programCountEachQuarter
              },
            });
        setIsEnrolledFromUrl(true);
      }
    } finally {
      // Reset the enrolling flag after success
      isEnrolling.current = false;
    }
  };
  const handleUnEnroll = async () => {
    try {
      dispatch({ type: ActionType.SET_LOADING, payload: true });

      await apis.unEnrollProgram(enrolledId);
      dispatch({ type: ActionType.SET_LOADING, payload: false });

      enrollUser();
    } catch (error) {
      console.log('error', error);
    }
  };
  const isDisabled = !isEnrollmentDateAvailable(Props.quaterStartDate?.start) ? true: !isEnrollmentDateAvailable(Props.quaterStartDate?.start) || +Props.year !== new Date().getFullYear() ?true :false

  // New function to check if enrollment is eligible
  const checkEnrollmentEligibility = () => {
    //nothing any action perform if user change system date
    if(!checkCurrentDate(state?.user?.currentDate) )
      return

     const queryParams = new URLSearchParams(location.search);
     const isEnrolled = queryParams.get("enrolled") === "true";
    if (
      (!isEnrollmentDateAvailable(Props.quaterStartDate?.start) ||
        +Props.year !== new Date().getFullYear()) &&
      !isEnrolled
    ) {
      setIsEnrollmentEligible(true);
    } else {
      setIsEnrollmentEligible(false);
    }
  };

  const shouldShowGoToProgram = Props.isEnroll || Props.name === enrolledName || isEnrolledFromUrl;

if (shouldShowGoToProgram) {
  Props.setIsListing?.(true);
}

  return (
    <>
      {!enrolledId && !shouldShowGoToProgram ? (
        <Button
        className={`w-${Props.width} ${Props.color ? 'bg-[#212930] text-white border-[1px]' : ''
          }  ${(!isEnrollmentDateAvailable(Props.quaterStartDate?.start) || +Props.year !== new Date().getFullYear() )  || checkCurrentDate(state?.user?.currentDate) === false ? 'hover:bg-[#cccccc] disabled:opacity-[1] bg-[#cccccc] dark:text-[#666666]'
              : "cursor-pointer"
          }   mt-12 h-auto py-2 text-base mb-4 truncate block`}
          onClick={isDisabled ? checkEnrollmentEligibility : handleEnroll}
          style={{
            pointerEvents: isDisabled ? "auto" : "auto", // Ensure pointer events work even if visually disabled
          }}
        >
          {t('Program.enrollNow')}
        </Button>
      ) : shouldShowGoToProgram ? (
       
        <Button
          className={`w-${Props.width} flex gap-2 mt-12 h-auto py-2 text-base mb-4 truncate`}
          
          onClick={() => navigate(`/program/${Props.programId}`)}
        >
          {t("Program.goToProgram")}
          <SvgIcon
            iconName="right-line-arrow"
            svgProp={{
              className: "logo cursor-pointer",
            }}
          />
        </Button>
      ) : (
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button
              disabled={
                !isEnrollmentDateAvailable(Props.quaterStartDate?.start)
                || !checkCurrentDate(state?.user?.currentDate)

              }
              className={`w-${Props.width} mt-12 ${
                Props.color ? "bg-[#212930] text-white border-[1px]" : ""
              } 
              ${!isEnrollmentDateAvailable(Props.quaterStartDate?.start) ? " bg-gray-50" : ""
              }  cursor-pointer   h-auto py-2 text-base mb-4 truncate block`}
            >
              {t('Program.enrollNow')}
            </Button>
          </AlertDialogTrigger>
          <AlertDialogContent className="bg-fillMidGrayCard border-0 py-12 px-16">
            <AlertDialogHeader>
              <AlertDialogTitle className="text-center text-xl mb-5 font-barlowMedium tracking-wide">
                {t('EnrollModal.unenroll')}
              </AlertDialogTitle>
              <AlertDialogDescription className="text-start">
                <p className="text-white text-lg mb-2 font-barlowRegular tracking-wide">
                  {t('EnrollModal.unenrollFromPrev')} {enrolledName}{" "}
                  {t('EnrollModal.enrolledTo')} {Props.name}
                </p>
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter className="lg:justify-center lg:space-x-5">
              <AlertDialogCancel className="w-full bg-transparent font-opensansSemiBold">
                {t('EnrollModal.no')}
              </AlertDialogCancel>
              <AlertDialogAction
                className="w-full font-opensansSemiBold"
                onClick={() => handleEnroll()}
              >
                {t('EnrollModal.yes')}
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      )}

      {isEnrollmentEligible && (
        <>
          <AlertDialog open={isEnrollmentEligible}>
            <AlertDialogContent className="bg-fillMidGrayCard border-0 py-12 px-16">
              <AlertDialogHeader>
                <AlertDialogDescription className="text-start">
                  <p className="text-white text-lg mb-2 font-barlowRegular tracking-wide">
                    {t("EnrollModal.programNotStarted")}
                  </p>
                </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter className="lg:justify-center lg:space-x-5">
                <AlertDialogAction
                  onClick={() => setIsEnrollmentEligible(false)}
                  className="w-full font-opensansSemiBold"
                >
                  {t("EnrollModal.ok")}
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        </>
      )}
    </>
  );
};
export default React.memo(EnrollUser);
